import { render, staticRenderFns } from "./CUBannerForm.vue?vue&type=template&id=0ad2760a"
import script from "./CUBannerForm.vue?vue&type=script&lang=js"
export * from "./CUBannerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports